export const CREATING_PROGRAMME = 'Creating Programme';
export const RETRIEVE_ALL_PROGRAMMES = 'Retrieving All Programmes';
export const RETRIEVE_PROGRAMME = 'Retrieving Programme';
export const UPDATING_PROGRAMME = 'Updating Programme';
export const PUBLISHING_PROGRAMME = 'Publishing Programme';
export const DOWNLOADING_TEAM_LEADERBOARD_EXCEL = 'Downloading Team Leaderboard Excel';
export const SENDING_MEMBER_COMMUNICATIONS = 'Send Member Communications';
export const UPLOADING_MEMBER_EXCEL = 'Uploading Member Excel';
